module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "balmoral.ed0ca26d.svg";